import {
  Dumbbell,
  PlayCircle,
  DollarSign,
  Users,
  Globe,
  Apple,
  Target,
  Salad,
  Infinity,
} from "lucide-react";

const Benefits = () => {
  const items = [
    {
      title: "Clinical Dietitians",
      desc: "For real in-depth assessment & weight management.",
      icon: <Salad size={28} className="text-lime-600" />,
      color: "bg-lime-100",
    },

    {
      title: "Weight Loss Programs",
      desc: "Scientifically designed, trainer-led sessions to shed fat effectively.",
      icon: <Dumbbell size={28} className="text-red-500" />,
      color: "bg-red-100",
    },
    {
      title: "Live & Recorded Workouts",
      desc: "Yoga, cardio, strength, dance, HIIT – do what you enjoy.",
      icon: <PlayCircle size={28} className="text-blue-500" />,
      color: "bg-blue-100",
    },
    {
      title: "Affordable & Accessible",
      desc: "Pay less than the price of a gym & trainer fees & travel expenses.",
      icon: <DollarSign size={28} className="text-green-600" />,
      color: "bg-green-100",
    },
    {
      title: "Expert Trainers",
      desc: "Certified coaches guiding you step by step.",
      icon: <Users size={28} className="text-purple-500" />,
      color: "bg-purple-100",
    },
    {
      title: "Anytime. Anywhere.",
      desc: "Workout from your living room, balcony, or while traveling.",
      icon: <Globe size={28} className="text-orange-500" />,
      color: "bg-orange-100",
    },
    {
      title: "Nutrition Guidance",
      desc: "Complete assessment and customised meal planning.",
      icon: <Apple size={28} className="text-pink-500" />,
      color: "bg-pink-100",
    },
    {
      title: "Accountability Support",
      desc: "Stay on track with regular checks & guidance by our team.",
      icon: <Target size={28} className="text-indigo-500" />,
      color: "bg-indigo-100",
    },
    {
      title: "Lifetime Support",
      desc: "Pay just once & get lifetime assistance from Client Success Managers & Dieticians.",
      icon: <Infinity size={28} className="text-indigo-600" />,
      color: "bg-indigo-100",
    },
  ];

  return (
    <section className="py-20 px-6 lg:px-20 bg-gradient-to-b from-white to-gray-50">
      {/* Heading */}
      <div className="text-center mb-14">
        <h4 className="text-orange-500 font-semibold uppercase tracking-wide">
          Benefits
        </h4>
        <h2 className="text-4xl font-bold text-gray-900 mt-2">Why Revibe?</h2>
        <p className="mt-4 text-lg text-gray-600 italic max-w-2xl mx-auto">
          “The easiest way to get fit without stepping into a gym.”
        </p>
      </div>

      {/* Responsive Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {items.map((item, index) => (
          <div
            key={index}
            className="bg-white rounded-2xl shadow-md hover:shadow-xl transition transform hover:-translate-y-1 p-8"
          >
            <div className="flex items-center space-x-4 mb-4">
              <div className={`p-3 rounded-xl ${item.color}`}>{item.icon}</div>
              <h3 className="text-lg font-semibold text-gray-900">
                {item.title}
              </h3>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Benefits;
